import teamCollaboration from "@/assets/team-collaboration.jpg";

const Values = () => {
  return (
    <section className="py-20 relative overflow-hidden">
      {/* Parallax Background */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-fixed"
        style={{
          backgroundImage: `url(${teamCollaboration})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      />
      
      {/* Dark Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/70 to-black/75" />
      
      {/* Pattern Overlay */}
      <div 
        className="absolute inset-0 opacity-10" 
        style={{ 
          backgroundImage: `repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(255,255,255,0.05) 2px, rgba(255,255,255,0.05) 4px)`
        }} 
      />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center animate-fade-in">
          {/* Liquid Glassmorphism Container */}
          <div className="glass-liquid-dark-heavy p-8 md:p-12 rounded-3xl backdrop-blur-2xl border border-border-glass-heavy shadow-liquid-xl">
            <h2 
              className="text-3xl md:text-4xl lg:text-5xl font-montserrat font-bold mb-6 text-white text-balance leading-tight"
              style={{ textShadow: '0 2px 10px rgba(0, 0, 0, 0.3), 0 4px 20px rgba(0, 0, 0, 0.2)' }}
            >
              VALORAMOS TU CONFIANZA, POR ESO LA HONRAMOS EN CADA PASO.
            </h2>
            <p 
              className="text-lg md:text-xl text-white/90 font-inter leading-relaxed"
              style={{ textShadow: '0 1px 3px rgba(0, 0, 0, 0.3)' }}
            >
              La importancia de trabajar juntos para el éxito de cada proyecto.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Values;
